import { defineSlotRecipe } from '@chakra-ui/react';
import { radioCardAnatomy } from '@chakra-ui/react/anatomy';

import { FORM_FIELD_CLASS_NAME } from '~/core/shared/constants/styles';

export default defineSlotRecipe({
  slots: radioCardAnatomy.keys(),
  base: {
    item: {
      alignSelf: 'stretch',
      alignItems: 'center',
      cursor: 'pointer',
      display: 'flex',
      transition: 'all 150ms',
    },
    itemIndicator: {
      '& > .dot': {
        scale: 1,
      },
    },
  },
  defaultVariants: {
    variant: 'default',
  },
  variants: {
    variant: {
      default: {
        root: {
          gap: 2.5,
        },
        itemIndicator: {
          borderColor: 'secondary.200',
          borderRadius: 'full',
          borderWidth: '2px',
          boxSize: 6,
          transition: 'all 250ms',
          _checked: {
            borderColor: 'secondary.800',
            borderWidth: '6px',
            bg: 'primary.500',
          },
          _invalid: { borderColor: 'red.500' },
        },
        item: {
          borderWidth: '1px',
          p: 4,
          fontWeight: 'normal',
          transition: 'all 250ms',
          _checked: {
            bg: 'secondary.700',
            borderColor: 'primary.400',
          },
        },
        itemControl: {
          p: 0,
          w: 'full',
        },
        itemText: {
          fontSize: 'md',
          fontWeight: 'normal',
        },
      },
      tab: {
        root: {
          [`& > *:not(:first-of-type:not(.${FORM_FIELD_CLASS_NAME}))`]: {
            borderLeftWidth: '1px',
          },
          borderRadius: 'sm',
          borderWidth: '1px',
          display: 'flex',
          flexDirection: 'row',
          gap: 0,
          bg: 'white',
        },
        item: {
          justifyContent: 'center',
          w: 'full',
          borderRadius: '0',
          bg: 'white',
          _focus: { bg: 'white' },
        },
        itemControl: {
          p: 0,
        },
        itemIndicator: {
          display: 'none',
        },
        itemText: {
          fontWeight: 'normal',
          fontSize: 'lg',
          px: 4,
          py: 2,
          _checked: {
            fontWeight: 'semibold',
          },
        },
      },
      tile: {
        root: {
          display: 'grid',
          gap: '20px',
          gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
          '& .chakra-icon': {
            boxSize: 16,
            mb: 4,
          },
        },
        item: {
          borderWidth: '1px',
          _invalid: { borderColor: 'red.500' },
          _checked: {
            borderColor: 'navy.500',
            borderStyle: 'solid',
            borderWidth: '1px',
            shadow: 'md',
          },
          _focus: { bg: 'transparent' },
        },
        itemControl: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          maxW: '196px',
          minH: '196px',
          p: 8,
          w: 'full',
          _focus: { bg: 'transparent' },
        },
        itemIndicator: {
          display: 'none',
        },
        itemText: {
          textAlign: 'center',
        },
      },
    },
  },
});
